import React, { useEffect, useState } from 'react';
import LoadingScreen from '../../Shared/LoadingScreen';
import OpenSnackbar from '../../Shared/OpenSnackbar';
import Table from '../../Shared/Table';
import { Link } from 'react-router-dom';
import getLicenseApiKeys from '../../Store/Actions/GetLicenseApiKeys-Action';
import { licenseApiKeysActions } from '../../Store/Reducers/LicenseApiKeys-reducer';
import { useDispatch, useSelector } from 'react-redux';
import LoadMoreItems from '../../Shared/LoadMoreItemsScreen';
import { useErrorHandler } from 'react-error-boundary';
import Chip from '../../Shared/StatusChip';
const LicenseApiKeyComp = () => {
  const dispatch = useDispatch();
  const { apiKeys, isLoading, isLoaded, status, lastEvaluatedkey, loadMore } = useSelector((state) => state.LicenseApiKeys);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const ErrorHandler = useErrorHandler();
  const [snackbarDetails, setSnackbarDetails] = useState({
    message: "",
    type: "",
  });
  const handleSnackbarOpen = (message, type) => {
    let obj = {
      message,
      type,
    };
    setSnackbarDetails(obj);
    setSnackbarOpen(true);
  };
  useEffect(() => {
    if (!isLoaded) {
      dispatch(getLicenseApiKeys(lastEvaluatedkey));
      dispatch(licenseApiKeysActions.setIsLoaded(true));
    }
  }, [isLoaded]);
  useEffect(() => {
    if (status !== "") {
      ErrorHandler(() => {
        throw new Error(status);
      });
      handleSnackbarOpen(status, "errorDark");
    }
    return () => {
      setSnackbarOpen(false);
      setSnackbarDetails({
        message: "",
        type: "",
      });
    };
  }, [status]);

  const getTime = (time) => {
    let key = parseInt(time);
    return (
      new Date(key).toDateString() +
      " " +
      new Date(key).getHours() +
      ":" +
      new Date(key).getMinutes() +
      ":" +
      new Date(key).getSeconds()
    );
  };
  const formatData = (data) => {
    let formattedData = data.map((item, index) => ({
      restaurant_name: item.restaurant_name || "—",
     api_key_name: item.api_key_name || "—",
      id: item.id || "—",
      created_at: item.created ? getTime(item.created) : "—",
      id_type: item.id_type || "—",
      api_key_status: item?.status ? (
        <Chip
          index={index}
          setLoading={() => {}}
          handleSnackbarOpen={handleSnackbarOpen}
          isLoading={isLoaded}
          data={apiKeys}
          comp="license"
          statusKey="status"
          itemId={item?.api_key}
        />
      ) : (
        "—"
      ),
    }));
    return formattedData;
  };
  const columns = [
    {
      name: "restaurant_name",
      label: "Restaurant Name",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "api_key_name",
      label: "Apikey Name",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "id",
      label: "Id",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "id_type",
      label: "Id Type",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "created_at",
      label: "Created At",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "api_key_status",
      label: "Status",
      options: {
        sort: true,
        filter: true,
      },
    },
  ];
  const onTableChangeHandler = (action, tableState) => {
    // const { page, rowsPerPage, data } = tableState;
    // let diff = Math.abs(page * rowsPerPage - data.length);
    // if (diff <= rowsPerPage && lastEvaluatedkey?.id?.length > 0 && (action === "changePage" || action === "changeRowsPerPage")) {
    //   dispatch(licenseApiKeysActions(lastEvaluatedkey));
    //   return;
    // }
  };
  return (
    <>
      {isLoading ? (
        <LoadingScreen loading={isLoading} />
      ) : (
        <>
          {loadMore && <LoadMoreItems loading={loadMore} />}
          <Table data={formatData(apiKeys)} columns={columns} title="License Apikeys" onTableChange={onTableChangeHandler} />
          {snackbarOpen && (
            <OpenSnackbar
              message={snackbarDetails.message}
              type={snackbarDetails.type}
              open={snackbarOpen}
              setOpen={setSnackbarOpen}
              vertical="bottom"
              horizontal="center"
            />
          )}
        </>
      )}
    </>
  );
};

export default LicenseApiKeyComp;
